import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'full-height-wrapper',
  templateUrl: './full-height-wrapper.component.html',
  styleUrls: ['./full-height-wrapper.component.scss'],
  standalone: false,
})
export class FullHeightWrapperComponent {
  @ViewChild('div') div: ElementRef<HTMLDivElement>;

  @Input() classes?: string;

  get shouldUseCalcolatedHeight(): boolean {
    return this.classes?.includes('calcolated');
  }
}
